import {combineReducers} from 'redux';
import tokenReducer from "./auth/tokenReducer";
import tableDataReducer from "./table/tableDataReducer";
import formDataReducer from "./form/formDataReducer";

export default combineReducers({
    auth: tokenReducer,
    dataTable: tableDataReducer,
    dataForm: formDataReducer,
});